import { BookmarkBorder } from "@material-ui/icons";
import React, { useState } from "react";
import { useFilterContext } from "./State/FilterContext";
import { Button, Menu, MenuItem } from "@material-ui/core";
import { NamedGroopitFilterDisplayDTO } from "groopit-js/client";
import { SaveFilterDialog } from "./SaveFilterDialog";
import { useGroupContext } from "groopit-js";
import { isDefaultFilter } from "./GroopitFilterDTO";

export const SaveFilterButton = () => {
  const { user_id, owner } = useGroupContext();
  const { filter } = useFilterContext();
  const [showExistingFilterMenu, setShowExistingFilterMenu] =
    useState<HTMLElement | null>(null);
  const [showNameFilterDialog, setShowNameFilterDialog] = useState<
    [showDialog: boolean, mode: "save" | "save_as"]
  >([false, "save"]);
  const canUpdatefilter =
    filter instanceof NamedGroopitFilterDisplayDTO &&
    (owner || filter.creator.id === user_id);

  return (
    <>
      <Button
        color="default"
        disabled={isDefaultFilter(filter)}
        onClick={(e) =>
          canUpdatefilter
            ? setShowExistingFilterMenu(e.currentTarget)
            : setShowNameFilterDialog([true, "save_as"])
        }
      >
        <BookmarkBorder fontSize="inherit" className="mr-1" />
        {canUpdatefilter ? <span>Save&hellip;</span> : <span>Save</span>}
      </Button>
      <Menu
        anchorEl={showExistingFilterMenu}
        open={Boolean(showExistingFilterMenu)}
        onClose={() => setShowExistingFilterMenu(null)}
      >
        <MenuItem
          onClick={() => {
            setShowNameFilterDialog([true, "save"]);
            setShowExistingFilterMenu(null);
          }}
        >
          Resave filter
        </MenuItem>
        <MenuItem
          onClick={() => {
            setShowNameFilterDialog([true, "save_as"]);
            setShowExistingFilterMenu(null);
          }}
        >
          Save as new filter
        </MenuItem>
      </Menu>
      <SaveFilterDialog
        open={showNameFilterDialog[0]}
        filter={filter}
        onClose={() => setShowNameFilterDialog([false, "save"])}
        mode={showNameFilterDialog[1]}
      />
    </>
  );
};
